import { useEffect, useState } from "react";
import { useDevice } from "get-life-storybook-ts/lib/components/Hooks";
import {
  ErrorI,
  isPhone,
  isEmail
} from "get-life-storybook-ts/lib/components/Validations";
import prepareCapitals from "../../helpers/Capitals/prepareCapitals";
export interface StrapiDataCalculator {
  data: { Url: string; Promo?: string }[];
}

interface Validations extends ErrorI<string | number> {}

interface FormDataFirstI {
  birthDate: string;
  capital: number | string;
  haveInsurance: string;
  redirect?: boolean;
}

interface GlobalInfoI {
  defaultcap: string | null;
  gtf_campaign: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  tid: string | null;
  url: any;
}

interface FormDataSecondI {
  phone: string;
  email: string;
  checkedConditions: string | boolean;
  checkedConditions2: string | boolean;
}

const optionsHaveInsurance = [
  {
    label: "Si",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];
const errorMessages: any = {
  birthDate: "La edad introducida no es asegurable",
  haceInsurance: "Por favor seleccione una opción",
  capital: "Por favor seleccione un capital",
  phone: "Por favor inserte un número de teléfono correcto",
  email: "Por favor inserte un correo electrónico correcto",
  checkedConditions: "Debe aceptar el tratamiento de datos para continuar",
  checkedConditions2: "Debe aceptar las condiciones para continuar",
};

const API_URL = process.env.GATSBY_API_URL;

const CalculatorModuleController = ({ data }: StrapiDataCalculator) => {
  const [formError, setFormError] = useState<any>();
  const [capitalOptions, setCapitalOptions] = useState<any>([]);
  const [actualStep, setActualStep] = useState(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(false);
  const [leadId, setLeadId] = useState<string>("");
  const { isMobile, isDesktop, isTablet } = useDevice();

  const [globalInfo, setGlobalInfo] = useState<GlobalInfoI>({
      defaultcap: "",
      gtf_campaign: data[0]?.Promo || "3MESES1E",
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      tid: "",
      url: "",
  });

  const [formDataFirst, setFormDataFirst] = useState<FormDataFirstI>({
    birthDate: "",
    capital: 0,
    haveInsurance: "",
    redirect: false,
  });

  const [formDataSecond, setFormDataSecond] = useState<FormDataSecondI>({
    phone: "",
    email: "",
    checkedConditions: "",
    checkedConditions2: ""
  });

  useEffect(() => {
    (async () => {
      if (formDataFirst.birthDate) {
        if (typeof window !== "undefined") {
          try {
            await fetch(
              `${API_URL}/public/age/validation/${formDataFirst.birthDate}`
            ).then((response) =>  {
              if (response.status === 400) {
                throw new Error;
              } else {
                return response.json()
              }
            }) 
            const capitals = await fetch(
              `${API_URL}/lead/capital/tarifier/pureBoundaries/${formDataFirst.birthDate}`
            )
              .then((response) => response.json()) // parse JSON from request
              .then((resultData) => {
                return resultData;
              });

            const { options, indexPreSelected } = prepareCapitals({ capitals });

            setCapitalOptions(options);

            if (globalInfo.defaultcap) {
              let capital = options.find(
                (element) => element.value === parseInt(globalInfo.defaultcap!)
              );

              if (capital) {
                setFormDataFirst({
                  ...formDataFirst,
                  capital: capital!.value,
                  redirect: capital!.redirect ? true : false,
                });
                setFormError({
                  ...formError,
                  birthDate: { error: false, message: "" },
                });
              } else {
                setFormDataFirst({
                  ...formDataFirst,
                  capital: options[indexPreSelected].value,
                  redirect: options[indexPreSelected].redirect ? true : false,
                });
                setFormError({
                  ...formError,
                  birthDate: { error: false, message: "" },
                });
              }
            } else {
              setFormDataFirst({
                ...formDataFirst,
                capital: options[indexPreSelected].value,
                redirect: options[indexPreSelected].redirect ? true : false,
              });
              setFormError({
                ...formError,
                birthDate: { error: false, message: "" },
              });
            }
          } catch (error: any) {
            if (error.error) {
              setFormError({ ...formError, birthDate: error });
            } else {
              setFormError({
                ...formError,
                birthDate: { error: true, message: errorMessages.birthDate },
              });
            }
            setCapitalOptions([]);
          }
        }
      }
    })();
  }, [formDataFirst.birthDate]);

  const fieldValidation = async ({ data, key, newError }: any) => {
    if (key !== "redirect") {
      if (!data[key]) {
        newError = {
          ...newError,
          [key]: { error: true, message: errorMessages[key] },
        };
      } else if (key === "phone" && isPhone({ value: data[key] }).error) {
        newError = {
          ...newError,
          [key]: { error: true, message: errorMessages[key] },
        };
      } else if (key === "email") {
        const validEmail = await validateEmail(data[key]);
        if (!validEmail) {
        newError = {
          ...newError,
          [key]: { error: true, message: errorMessages[key] },
        };
      } else {
        newError = { ...newError, [key]: { error: false, message: "" } };
      }
      } else {
        newError = { ...newError, [key]: { error: false, message: "" } };
      }
    }
    return newError;
  };

  const validateEmail = async (email: string) => {  
    try {
      const response = await fetch(
        `${API_URL}/public/email/validator`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({email: email}),
        }
      )

      if (response.ok) {
        setFormError({ ...formError, email: { error: false, message: "" } });
        return true;
      } else {
        console.warn("⚠️ Validación fallida con status:", response.status);
        setFormError({ ...formError, email: { error: true, message: errorMessages.email } });
        return false;
      }
    } catch (error) {
      return false
    }
  };

  const handleChange = ({ setValue, value, field, formData }: any) => {
    let newData = { ...formData, [field]: value };
    // For email and phone: clear error on change, validate only on blur
    if ((field === "email" || field === "phone") && formError?.[field]?.error) {
      setFormError({ ...formError, [field]: { error: false, message: "" } });
    }
    setValue(newData);
  };

  const handleBlur = async ({ field, formData }: any) => {
    let newError: any = {};
    if (!!formData[field]) {
      newError = await fieldValidation({ data: formData, key: field, newError });
      setFormError({ ...formError, ...newError });
    }
  };

  const handleButton = () => {}

  return {
    actualStep,
    capitalOptions,
    display,
    formDataFirst,
    formDataSecond,
    formError,
    handleBlur,
    handleButton,
    handleChange,
    isMobile,
    loading,
    optionsHaveInsurance,
    setActualStep,
    setDisplay,
    setFormDataFirst,
    setFormDataSecond,
  };
};

export default CalculatorModuleController;
